import { render, staticRenderFns } from "./product-categories-tree-modal.vue?vue&type=template&id=422bf1b8&scoped=true&"
import script from "./product-categories-tree-modal.vue?vue&type=script&lang=js&"
export * from "./product-categories-tree-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-categories-tree-modal.vue?vue&type=style&index=0&id=422bf1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422bf1b8",
  null
  
)

export default component.exports